import { render, staticRenderFns } from "./OddsTable.vue?vue&type=template&id=353220d8&scoped=true"
import script from "./OddsTable.vue?vue&type=script&lang=js"
export * from "./OddsTable.vue?vue&type=script&lang=js"
import style0 from "./OddsTable.vue?vue&type=style&index=0&id=353220d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353220d8",
  null
  
)

export default component.exports